<template>
  <div class="eth-gas-options">
    <div class="text-5 font-weight-medium">Speed</div>
    <div class="d-flex mt-2">
      <div
        :class="[
          'option flex-1 d-flex align-center justify-center',
          type,
          { selected: item.text === selectedOption.text },
        ]"
        v-for="item in options"
        :key="item.text"
        @click="selectedOption = item"
      >
        <div class="text-center">
          <div class="text-4 line-height-25">{{ item.text }}</div>
          <div class="mt-1 text-6 gray--text" v-if="item.wait">
            {{ item.wait }}
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex mt-10" v-if="selectedOption.isAdvance">
      <div class="flex-1">
        <div class="text-5">Gas Limit</div>
        <v-text-field
          v-model="form.gas"
          type="number"
          outlined
          single-line
          class="c-input input-gas mt-2"
          placeholder="0"
          hide-details="auto"
          suffix="GWEI"
          @input="updateForm"
        ></v-text-field>
      </div>
      <div class="flex-1 ml-6">
        <div class="text-5">Max. Priority Fee</div>
        <v-text-field
          v-model="form.maxPriorityFeePerGas"
          type="number"
          outlined
          single-line
          class="c-input input-gas mt-2"
          placeholder="0"
          hide-details="auto"
          suffix="GWEI"
          @input="updateForm"
        ></v-text-field>
      </div>
      <div class="flex-1 ml-6">
        <div class="text-5">Max. Fee</div>
        <v-text-field
          v-model="form.maxFeePerGas"
          type="number"
          outlined
          single-line
          class="c-input input-gas mt-2"
          placeholder="0"
          hide-details="auto"
          suffix="GWEI"
          @input="updateForm"
        ></v-text-field>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { hexlifyObj } from "@/common/lib/utils";
import BN from "bignumber.js";
export default {
  props: {
    gasLimit: Number,
    type: String,
  },
  computed: {
    ...mapGetters({
      gasPrices: "appConfig/ethGasPrices",
    }),
    options() {
      return [
        {
          text: "Slow",
          wait: "> 10 minutes",
          maxFeePerGas: this.gasPrices?.slow,
          maxPriorityFeePerGas: this.gasPrices?.priority?.slow,
        },
        {
          text: "Standard",
          wait: "3 minutes",
          maxFeePerGas: this.gasPrices?.standard,
          maxPriorityFeePerGas: this.gasPrices?.priority?.standard,
        },
        {
          text: "Fast",
          wait: "1 minute",
          maxFeePerGas: this.gasPrices?.fast,
          maxPriorityFeePerGas: this.gasPrices?.priority?.fast,
        },
        {
          text: "Advance",
          wait: "Custom",
          isAdvance: true,
        },
      ];
    },
    formHexlified() {
      return hexlifyObj({
        gas: Number(this.form.gas),
        maxFeePerGas: new BN(this.form.maxFeePerGas)
          .multipliedBy(1e9)
          .toNumber(),
        maxPriorityFeePerGas: new BN(this.form.maxPriorityFeePerGas)
          .multipliedBy(1e9)
          .toNumber(),
      });
    },
  },
  data: () => ({
    selectedOption: {},
    form: {
      gas: 0,
      maxFeePerGas: 0,
      maxPriorityFeePerGas: 0,
    },
  }),
  methods: {
    updateForm() {
      this.$emit("update", this.formHexlified);
    },
  },
  async mounted() {
    this.selectedOption = this.options[2];
    await this.$store.dispatch("appConfig/fetchEthGasPrice");
  },
  watch: {
    options() {
      if (!this.selectedOption.isAdvance) {
        this.selectedOption = this.options.find(
          item => item.text === this.selectedOption.text
        );
      }
    },
    selectedOption: {
      immediate: true,
      handler(opt) {
        this.form = {
          gas: this.form.gas || this.gasLimit,
          maxFeePerGas: opt.maxFeePerGas || this.form.maxFeePerGas,
          maxPriorityFeePerGas:
            opt.maxPriorityFeePerGas || this.form.maxPriorityFeePerGas,
        };
        this.updateForm();
      },
    },
    gasLimit(val) {
      this.form.gas = val;
      this.updateForm();
    },
  },
};
</script>

<style lang="scss" scoped>
.eth-gas-options {
  .option {
    height: 70px;
    border: 1px solid #f2f2f2;
    border-radius: 50px;
    &:not(:first-child) {
      margin-left: 16px;
    }
    &.selected {
      &.stake {
        border-color: var(--purple);
        background: rgba(233, 235, 255, 0.15);
      }
      &.vaults {
        border-color: var(--green);
        background: rgba(227, 249, 237, 0.15);
      }
    }
    &:not(.selected) {
      opacity: 0.5;
      mix-blend-mode: luminosity;
      &:hover {
        opacity: 1;
        mix-blend-mode: normal;
        cursor: pointer;
        &.vaults {
          border-color: var(--green);
          background: rgba(227, 249, 237, 0.15);
        }
        &.stake {
          border-color: var(--purple);
          background: rgba(233, 235, 255, 0.15);
        }
      }
    }
  }
}
</style>
